import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { QuestionnaireSelectionCategory } from 'src/app/core/api/questionnaire-selection.util';

@Component({
  selector: 'csi-questionnaire-category-picker',
  templateUrl: './questionnaire-category-picker.component.html',
  styleUrls: ['./questionnaire-category-picker.component.css']
})
export class QuestionnaireCategoryPickerComponent implements OnChanges {
  @Input() formGroup: FormGroup;
  @Input() categories: QuestionnaireSelectionCategory[] = [];

  @Output() selectionChange = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.categories || changes.formGroup) && this.formGroup && this.categories) {
      this.ensureCategoryControls();
    }
  }

  public onItemChange() {
    this.selectionChange.emit();
  }

  public trackByCategoryId(_index: number, category: QuestionnaireSelectionCategory): string {
    return category.id;
  }

  private ensureCategoryControls() {
    this.categories.forEach(category => {
      Object.keys(category.itemKeyToNamePairs || {}).forEach(key => {
        this.ensureControl(key);
      });
    });
  }

  private ensureControl(key: string) {
    if (this.formGroup && !this.formGroup.controls[key]) {
      this.formGroup.addControl(key, new FormControl(false));
    }
  }
}
